import { Component, OnInit, ViewEncapsulation, OnDestroy } from '@angular/core';
import { AppSettings } from '../../../app.settings';
import { Settings } from '../../../app.settings.model';
import { MenuService } from '../menu/menu.service';
import { UsersService } from '../../../../../models/usuarios.service';
import { Subscription } from 'rxjs';
import { environment }  from '../../../../environments/environment';

@Component({
  selector: 'app-sidenav',
  templateUrl: './sidenav.component.html',
  styleUrls: ['./sidenav.component.scss'],
  encapsulation: ViewEncapsulation.None,
  providers: [ MenuService ]
})
export class SidenavComponent implements OnInit, OnDestroy {
  public userImage= '../assets/img/users/user.jpg';
  public menuItems:Array<any>;
  public settings: Settings;
  fornecedor:number;
  user:any={};
  loginChanged:Subscription = new Subscription();

  get logo(){
    return environment.site.logo;
  }
  get nomeLoja(){
    return environment.site.nome;
  }

  constructor(
     public appSettings:AppSettings, 
     public menuService:MenuService,
     private usersService:UsersService){
      this.settings = this.appSettings.settings; 
      this.loginChanged = usersService.loginChange.subscribe(r=>{
        if (usersService.logado)
         this.user = usersService.usuario
        else this.user = {}; 
      })
  }

  get users(){
    return this.usersService;
  }


  ngOnInit() {
    this.menuItems = this.menuService.getVerticalMenuItems();
    if (this.usersService.logado)
       this.user = this.usersService.usuario
    this.fornecedor = this.usersService.fornecedor;
  }

  ngOnDestroy(): void {
    //Called once, before the instance is destroyed.
    //Add 'implements OnDestroy' to the class.
    this.loginChanged.unsubscribe();
  }

  
  membroDesde(){
    let dt: Date = new Date();
    if (this.user.dtatualiz)
     try{
       dt = this.user.dtatualiz.toDate();
     } catch(e){
       dt = this.user.dtatualiz;
     }
    return dt.toLocaleDateString();
  }    
  

  public closeSubMenus(){
    let menu = document.querySelector(".sidenav-menu-outer");
    if(menu){
      for (let i = 0; i < menu.children[0].children.length; i++) {
        let child = menu.children[0].children[i];
        if(child){
          if(child.children[0].classList.contains('expanded')){
              child.children[0].classList.remove('expanded');
              child.children[1].classList.remove('show');
          }
        }
      }
    }
  }

}
